/**
 * Armazenamento local do Field App — rascunhos e fila de envio.
 *
 * IndexedDB e não localStorage: as fotografias são Blobs, e o localStorage só
 * guarda texto. Converter para base64 inchava tudo em ~33% e estourava a
 * quota de 5 MB com três fotografias.
 *
 * Duas coisas vivem aqui:
 *
 *  RASCUNHO — o formulário a meio. Se a aplicação fechar, o telefone morrer
 *  ou o agente sair sem querer, o trabalho não se perde. Há um só rascunho
 *  de cada vez, porque o agente está a atender uma pessoa de cada vez.
 *
 *  FILA (outbox) — cadastros prontos que ainda não chegaram ao servidor.
 *  O agente termina, guarda-se aqui, e envia-se quando houver rede. Para o
 *  agente o trabalho está feito; para nós está em trânsito.
 */

const BD = 'dozy-field';
const VERSAO = 1;
const RASCUNHOS = 'rascunhos';
const FILA = 'fila';

let promessaBD = null;

function abrir() {
  if (promessaBD) return promessaBD;
  promessaBD = new Promise((resolve, reject) => {
    if (!('indexedDB' in window)) {
      reject(new Error('Este browser não guarda dados offline.'));
      return;
    }
    const pedido = indexedDB.open(BD, VERSAO);
    pedido.onupgradeneeded = () => {
      const db = pedido.result;
      if (!db.objectStoreNames.contains(RASCUNHOS)) db.createObjectStore(RASCUNHOS);
      if (!db.objectStoreNames.contains(FILA)) {
        db.createObjectStore(FILA, { keyPath: 'id', autoIncrement: true });
      }
    };
    pedido.onsuccess = () => resolve(pedido.result);
    pedido.onerror = () => reject(pedido.error);
  });
  return promessaBD;
}

function transacao(loja, modo, accao) {
  return abrir().then((db) => new Promise((resolve, reject) => {
    const t = db.transaction(loja, modo);
    const s = t.objectStore(loja);
    let resultado;
    try { resultado = accao(s); } catch (e) { reject(e); return; }
    t.oncomplete = () => resolve(resultado && resultado.result !== undefined ? resultado.result : resultado);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error);
  }));
}

// ── Rascunho ────────────────────────────────────────────────
export const guardarRascunho = (dados) =>
  transacao(RASCUNHOS, 'readwrite', (s) => s.put({ ...dados, guardado_em: Date.now() }, 'actual'))
    .catch((e) => { console.warn('rascunho:', e.message); });

export const lerRascunho = () =>
  transacao(RASCUNHOS, 'readonly', (s) => s.get('actual')).catch(() => null);

export const apagarRascunho = () =>
  transacao(RASCUNHOS, 'readwrite', (s) => s.delete('actual')).catch(() => {});

// ── Fila de envio ───────────────────────────────────────────
export const porNaFila = (item) =>
  transacao(FILA, 'readwrite', (s) => s.add({
    ...item, criado_em: Date.now(), tentativas: 0, ultimo_erro: null,
  }));

export const lerFila = () =>
  transacao(FILA, 'readonly', (s) => s.getAll()).then((r) => r || []).catch(() => []);

export const removerDaFila = (id) =>
  transacao(FILA, 'readwrite', (s) => s.delete(id)).catch(() => {});

export const actualizarNaFila = (item) =>
  transacao(FILA, 'readwrite', (s) => s.put(item)).catch(() => {});

/** Há quanto tempo, em texto curto. */
export const desde = (ts) => {
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 60) return 'agora';
  if (s < 3600) return `há ${Math.floor(s / 60)} min`;
  if (s < 86400) return `há ${Math.floor(s / 3600)} h`;
  return `há ${Math.floor(s / 86400)} d`;
};
